class ExpandedAddToCartTrigger extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    this.state = {
      productData: JSON.parse(this.els.variants.element.textContent),
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  handleClick (event) {
    event.preventDefault()

    window.BAO.dispatchEvent(
      window.BAO.EVENTS.EXPANDED_ADD_TO_CART_TRIGGER.CLICK,
      {
        productData: this.state.productData,
      },
    )
  }
}

window.BAO.ExpandedAddToCartTrigger = ExpandedAddToCartTrigger

customElements.define(
  'expanded-add-to-cart-trigger',
  ExpandedAddToCartTrigger,
  {
    extends: 'button',
  },
)
